import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { useRequest } from '../hooks/UseRequest'
import Loading from "./Loading";
import { setNotification } from "../redux/notificationSlice";
import { useDispatch } from 'react-redux'

export default function DownloadRcRecordingButton({ id }) {
  const request = useRequest()
  const dispatch = useDispatch()
  const [isRequesting, setIsRequesting] = useState(false)
  const downloadRcRecording = async (id) => {
    try {
      let endpoint = `${process.env.REACT_APP_API_DOMAIN}/rc_calling_recording/${id}`;
      request.setEndpoint(endpoint)
      const response = await request.get()
      if (response.data.success) {
        window.open(response.data.data.url, "_blank")
      } else {
        dispatch(setNotification({ type: 'error', body: 'Failed to get download file!' }))
      }
      setIsRequesting(false);
    } catch (error) {
      dispatch(setNotification({ type: 'error', body: 'Failed to get download file!' }))
      setIsRequesting(false);
    }
  }

  const handleClick = () => {
    if (isRequesting) return;
    setIsRequesting(true);
    downloadRcRecording(id)
  }

  return (
    <div>
      {
        isRequesting ? (
          <div className="loader-wrapper">
            <Loading size="is-size-6" />
          </div>
            )
            : (
            <button type="button" className="button is-primary" onClick={handleClick}>
              <FontAwesomeIcon icon={faDownload} />
            </button>
          )
      }
    </div>
  )
}
